import type { SVGProps } from 'react'

export function CaretRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 12 12" fill="none" {...props}>
      <path d="M4 2l4 4-4 4V2z" fill="currentColor" />
    </svg>
  )
}
